import { motion } from "framer-motion";
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";

export default function ImpressumPage() {
  return (
    <div>
      <section className="bg-zinc-50 py-16 md:py-24 border-b border-zinc-100">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link href="/" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-primary transition-colors mb-8">
              <ArrowLeft className="w-4 h-4" />
              Zurück zur Startseite
            </Link>
            <p className="text-primary font-bold tracking-wider uppercase text-sm mb-3">Rechtliches</p>
            <h1 className="text-3xl md:text-5xl font-bold text-zinc-900 mb-5 leading-tight">Impressum</h1>
          </motion.div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl">
          <motion.div
            className="prose prose-zinc max-w-none"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <div className="space-y-10 text-zinc-700 text-sm leading-relaxed">

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Angaben gemäß § 5 DDG</h2>
                <p>
                  Tür- und Torservice Britz<br />
                  Inhaber: Brigitte Britz<br />
                  Eichklingenweg 7<br />
                  74613 Öhringen-Eckartsweiler
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Kontakt</h2>
                <p>
                  Telefon: <a href="tel:0794133514" className="text-primary hover:underline">07941 / 33 51 4</a><br />
                  E-Mail: <a href="mailto:info@tts-britz.de" className="text-primary hover:underline">info@tts-britz.de</a>
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Umsatzsteuer-Identifikationsnummer</h2>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                  DE350398549
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
                <p>
                  Berufsbezeichnung: Metallbaumeister<br />
                  Zuständige Kammer: Handwerkskammer Heilbronn-Franken<br />
                  Betriebsnummer / Handwerksrollennummer: 55081<br />
                  Verliehen in der Bundesrepublik Deutschland
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                <p>
                  Brigitte Britz<br />
                  Eichklingenweg 7<br />
                  74613 Öhringen-Eckartsweiler
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">EU-Streitschlichtung</h2>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                  <a
                    href="https://ec.europa.eu/consumers/odr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline break-all"
                  >
                    https://ec.europa.eu/consumers/odr/
                  </a>
                  <br />
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Haftung für Inhalte</h2>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den
                  allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
                  verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
                  zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
                <p className="mt-3">
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
                  Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                  Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                  Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Haftung für Links</h2>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
                  haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
                  der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-zinc-900 mb-3">Urheberrecht</h2>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                  deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
                  außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
                  Autors bzw. Erstellers.
                </p>
              </div>

            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
